import React, { useState, useContext } from "react";
import signin from "../assets/img/others/signin.png";
import logo from "../assets/img/logo/bfc-logo-removebg-preview.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/User";
import { CartContext } from "../context/CartContext";
import { isMobileNo} from "../utils/validations"
import axios from "axios";
const Signin = () => {
  const navigate = useNavigate();
  const { state } = useLocation()
  const { signIn } = useContext(UserContext);
  const { fetchExistingCart } = useContext(CartContext);
  const [errorOtp, setErrorOtp] = useState("");
 const [mobileno, setMobileno] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [errorMobileno, setErrorMobileno] = useState("");

  const checkValidation = () => {

    let hasError = false;

    

    if (mobileno === "") {
          setErrorMobileno("Mandatory Mobile Number");
          hasError = true;
        } else if (!isMobileNo(mobileno)) {
          setErrorMobileno("Invalid Mobile Number");
          hasError = true;
        } else {
          setErrorMobileno("");
        }

    return hasError
  };

   const userLogin = async (e) => {
    e.preventDefault();
    if (checkValidation()) return;

    setIsLoading(true);
    setErrorMobileno("");
    setErrorOtp("");

    try {
      const response = await axios.post("https://admin.bookstore.bfcpublications.com/api/mobile_login", {
       
        mobile: mobileno,
      });

      // Success case: Navigate to OTP page without alert
      //console.log(response.data.user_id)
      if (response.data.user_id) {
        navigate("/otp", {
          state: {mobile: mobileno },
        });
      } else {
        // Handle server-side validation errors
        console.log(response.data);
        if (response.data.errors) {
         
          if (response.data.errors.mobile) {
            setErrorMobileno("Mobile number is not registered.");
          }
        } else {
          setErrorOtp(response.data.message || "Failed to send OTP. Please try again.");
        }
      }
    } catch (error) {
      if (error.response?.data?.errors) {
       
        if (error.response.data.errors.mobile) {
          setErrorMobileno("Mobile number is not registered.");
        }
      } else {
        setErrorOtp("Error sending OTP. Check your network or contact support.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>

      <section className=" login-bg pt-3">
        <div className="container">
          <div className="brand-logo ">
            <a href="/">
              <img src={logo} alt="" srcset="" className="img-fluid" />
            </a>
          </div>
          <div className="row align-items-stretch pt-5">
            <div className="col-md-7 d-md-block d-none">
              <img src={signin} alt="" srcset="" className="img-fluid" />
            </div>
            <div className="col-md-5 align-self-center">
              <div className="shadow p-3">
                <h4 className="pb-3 text_color ">Login using your credential</h4>
                <form>
                  <div className="form-group mb-4">
                    <input
                      class="search-input si"
                      type="tel"
                      name="mobile"
                      value={mobileno}
                      onChange={(e) => setMobileno(e.target.value)}
                      placeholder="Mobile Number"
                    />
                    <span style={{ color: "red" }}>{errorMobileno}</span>
                  </div>

                  <div className="form-group mt-4">
                    <button
                      type="submit"
                      class="fw-bold border-0 text-white login_btn rounded-pill bg_color w-100"
                      onClick={userLogin}
                      role="button"
                    >
                      Continue
                    </button>
                  </div>
                  <hr />
                  <p className="fs-14 text-rale">
                    New User Account?
                    <Link to="/signup" className="login-a text_color">
                      <b> Create Your Account </b>
                    </Link>
                   
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className=" login-bg pt-3">
        <div className="container">
          <div className="brand-logo ">
            <a href="/">
              <img src={logo} alt="" srcset="" className="img-fluid" />
            </a>
          </div>
          <div className="row align-items-stretch pt-5">
            <div className="col-md-7 ">
              <img src={signin} alt="" srcset="" className="img-fluid" />
            </div>
            <div className="col-md-5 align-self-center">
              <h4 className="pb-3 text-redc ">Login using your credential</h4>
              <form>
        
                <div className="form-group mb-4">
                  <input
                    class="search-input si"
                    type="text"
                    name="name"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Your Full Name"
                  />
                  <span style={{ color: "red" }}>{errorEmail}</span>
                </div>
             
                <div className="form-group mb-4">
                  <input
                    class="search-input si"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Your Email"
                  />
                  <span style={{ color: "red" }}>{errorEmail}</span>
                </div>
             
                <div className="form-group mb-4">
                  <input
                    class="search-input si"
                    type="tel"
                    name="mobile"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter Your Mobile Number"
                  />
                  <span style={{ color: "red" }}>{errorPassword}</span>
                </div>

                <div className="d-flex gap-2">
                  <div className=""><input type="checkbox" name="" id="" /></div>
                  <p className="login-first-step-para">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi a quisquam porro consectetur odit minus aut accusamus dolores magni eos?
                    <span>
                      <Link to="/signup" className="login-a">
                        <b> Click here</b>
                      </Link>
                    </span>
                  </p>
                </div>
                <div className="form-group mt-4">
                  <button
                    type="submit"
                    class="button-86 fw-bold"
                    onClick={userLogin}
                    role="button"
                  >
                    Continue
                  </button>
                </div>
                <hr />
                <p className="fs-14 text-rale">
                  Allready Have an account?
                  <Link to="/signup" className="login-a">
                    <b> Sign-In</b>
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};
export default Signin;
